/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
window.Pusher = require('pusher-js');

import Vue from 'vue';
import pinia from './stores';
import router from './routes';
import i18n from './localizations';

import './utils/bootstrap';
import './utils/bindings';

import App from './App';
import LoadingButton from './components/LoadingButton.vue';

import storage from './utils/storage';
import utils from './utils/utils';

Vue.prototype.$storage = storage;
Vue.prototype.$utils = utils;

Vue.component("LoadingButton", LoadingButton);

const app = new Vue({
    el: '#app',
    i18n,
    router,
    pinia,
    render: h => h(App)
});